import { Component, OnInit } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-reporte-seguimiento',
  templateUrl: './reporte-seguimiento.component.html',
  styleUrls: ['./reporte-seguimiento.component.css']
})
export class ReporteSeguimientoComponent implements OnInit {
  creditos: any[];
  opcionSeleccionada = 'general';
  cols = [
    {field: 'credit_folio', header: 'Folio de Crédito'},
    {field: 'nombre_completo', header: 'Nombre Completo'},
    {field: 'telefono', header: 'Teléfono'},
    {field: 'correo_electronico', header: 'Correo Electrónico'},
    // {field: 'tipo_cliente', header: 'Tipo de Cliente'},
  ]
  searchTerms = {
    numero_credito: '',
    nombre_completo: '',
    telefono: '',
    correo_electronico: '',
    tipo_cliente: '',
  }
  sortColumn: string = ''; // Columna actual de ordenación
  sortDirection: 'asc' | 'desc' = 'asc'; // Dirección de ordenación
  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchTerm: string = '';
  maxVisiblePages: number = 8; // Número máximo de páginas visibles

  constructor(private reportesService: ReportesService) { }

  ngOnInit(): void {
    this.consultaReporte();
  }

  consultaReporte() {
    this.creditos = [];
    if(this.opcionSeleccionada === 'general') {
      this.reportesService.executedCredits().subscribe( resp => {
        this.creditos = JSON.parse(JSON.stringify(resp));
      });
    } else {
      this.reportesService.executedCreditsByType(this.opcionSeleccionada).subscribe( resp => {
        this.creditos = JSON.parse(JSON.stringify(resp));
      });
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
  
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  
  goToEllipsisPage(position: 'first' | 'last'): void {
    if (position === 'first') {
      this.currentPage = 1;
    } else if (position === 'last') {
      this.currentPage = this.totalPages;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.filteredDataq.length / this.itemsPerPage);
  }

  get pages(): number[] {
    const totalPages = this.totalPages;
  
    if (totalPages <= this.maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePages / 2);
  
    let startPage = Math.max(1, this.currentPage - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);
  
    if (endPage === totalPages) {
      startPage = totalPages - this.maxVisiblePages + 1;
    }
    if (startPage === 1) {
      endPage = this.maxVisiblePages;
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  
    return pages;
  }

  pgone() {
    this.currentPage = 1;
  }

  sortData(column: string): void {
    // Cambia la dirección de ordenación si se selecciona la misma columna, de lo contrario reinicia a ascendente
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }

  private compare(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
    if (!column) return 0;
  
    const valueA = a[column];
    const valueB = b[column];
  
    let comparison = 0;
    if (valueA > valueB) {
      comparison = 1;
    } else if (valueA < valueB) {
      comparison = -1;
    }
  
    return direction === 'asc' ? comparison : -comparison;
  }

  get filteredDataq(): any[] {
    const filtered = this.creditos.filter(item => 
      (!this.searchTerms.numero_credito || (item.numero_credito && item.numero_credito.toLowerCase().includes(this.searchTerms.numero_credito.toLowerCase()))) &&
      (!this.searchTerms.nombre_completo || (item.nombre_completo && item.nombre_completo.toLowerCase().includes(this.searchTerms.nombre_completo.toLowerCase()))) &&
      (!this.searchTerms.telefono || (item.telefono && item.telefono.toLowerCase().includes(this.searchTerms.telefono.toLowerCase()))) &&
      (!this.searchTerms.correo_electronico || (item.correo_electronico && item.correo_electronico.toLowerCase().includes(this.searchTerms.correo_electronico.toLowerCase()))) &&
      (!this.searchTerms.tipo_cliente || (item.tipo_cliente && item.tipo_cliente.toLowerCase().includes(this.searchTerms.tipo_cliente.toLowerCase())))
    );
    return filtered.sort((a, b) => this.compare(a, b, this.sortColumn, this.sortDirection));
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredDataq.slice(startIndex, startIndex + this.itemsPerPage);
  }

  exportExcelFil() {
      let fullData = this.filteredDataq
      let date = new Date();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let start_date;

      if(month < 10){
        start_date =  `${year}-0${month}-${day}`;
      }else{
        start_date = `${year}-${month}-${day}`;
      }
      const readOpts = {
          cellText: false, 
          cellDates: true,
      };
     // Generar los datos personalizados para exportación
     const dataToExport = fullData.map(item => {
      const base = {};
  
      this.cols.forEach(col => {
        base[col.header] = item[col.field] || '';
      })
  
      return base;
     });
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
      const wb: XLSX.WorkBook = XLSX.utils.book_new(); 
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `seguimiento_${this.opcionSeleccionada}_${start_date}.xlsx`, readOpts);
    }

}
